import { FC } from "react";
import { Link as RouterLink } from "react-router-dom";

import { ConnectButton } from "@dzambalaorg/provider-wagmi";
import { Theme } from "@dzambalaorg/provider-theme";
import { EnabledLanguages } from "@dzambalaorg/constants";
import { Localization } from "@dzambalaorg/provider-localization";
import { AppShellLayout, Typography } from "@dzambalaorg/ui-kit";

import { Logo } from "../../../shared";
import { Sections } from "./sections";
import { StyledGrow, StyledLink, StyledToolbar } from "./styled";

export const Header: FC = () => {
  return (
    <AppShellLayout.Header>
      <StyledToolbar>
        <StyledLink component={RouterLink} to="/">
          <Logo width={40} height={40} />
          <Typography variant="h4">Cascadify - Office panel</Typography>
        </StyledLink>
        <StyledGrow />
        <Theme />
        <Localization languages={Object.values(EnabledLanguages)} />
        <ConnectButton />
        <Sections />
      </StyledToolbar>
    </AppShellLayout.Header>
  );
};
